import { type HistorySortDirection, type SortDirection } from 'api/donations/donationTypes';
import {
  DonationStatusForUpdate,
  type UpdateRemoteConfirmationDonationStatusesPayload,
} from 'api/remoteConfirmation/types';
import {
  CollectionStateUpdate,
  type CollectionStateUpdateItem,
} from 'features/donations/tabs/status-update/types';

export const toSortDirection = (direction: SortDirection): HistorySortDirection =>
  direction === 'desc' ? 'DESC' : 'ASC';

export const serializeDonationUpdatesForSubmit = (
  collectionStateUpdates: CollectionStateUpdateItem[],
): UpdateRemoteConfirmationDonationStatusesPayload['updates'] => {
  return collectionStateUpdates
    .filter(({ status }) => status !== CollectionStateUpdate.NOT_YET_COLLECTED)
    .map(({ orderId, status }) => ({
      orderId,
      status:
        status === CollectionStateUpdate.COLLECTED
          ? DonationStatusForUpdate.COLLECTED
          : DonationStatusForUpdate.NO_SHOW,
    }));
};
